module.exports = __webpack_public_path__ + "filter-icons-FFFFFF.7ce0ca113fd429885c9a.png";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/filter-icons-FFFFFF.png
// module id = ../../../../../client/assets/img/filter-icons-FFFFFF.png
// module chunks = styles